import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "bg-layer-1 rounded-xl p-6 w-full max-w-md border border-stroke-separator" }
const _hoisted_3 = { class: "text-lg font-medium mb-4" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_5 = { class: "rounded-lg py-2 px-4 border border-stroke-separator" }
const _hoisted_6 = { class: "text-sm text-text-neutral-high" }
const _hoisted_7 = { class: "text-lg text-text-neutral-extreme font-semibold mt-1" }
const _hoisted_8 = { class: "rounded-lg py-2 px-4 border border-stroke-separator" }
const _hoisted_9 = { class: "text-sm text-text-neutral-high" }
const _hoisted_10 = { class: "text-lg text-text-neutral-extreme font-semibold mt-1" }
const _hoisted_11 = { class: "mt-10 bg-layer-1 rounded-xl border border-stroke-separator hidden md:block" }
const _hoisted_12 = { class: "flex items-center justify-between px-3 py-3 border-b border-stroke-separator" }
const _hoisted_13 = ["onKeydown"]
const _hoisted_14 = { class: "flex items-center space-x-2 text-sm text-text-neutral-extreme" }
const _hoisted_15 = { class: "relative w-full overflow-x-auto" }
const _hoisted_16 = { class: "min-w-[720px] w-full text-sm table-fixed" }
const _hoisted_17 = { class: "divide-y divide-stroke-separator" }
const _hoisted_18 = { class: "py-4 px-3" }
const _hoisted_19 = { class: "py-4 px-3 whitespace-nowrap text-ellipsis overflow-hidden" }
const _hoisted_20 = { class: "py-4 px-3" }
const _hoisted_21 = { class: "py-4 px-3" }
const _hoisted_22 = { class: "flex items-center gap-1" }
const _hoisted_23 = { class: "capitalize" }
const _hoisted_24 = { class: "flex items-center justify-between px-4 py-4 border-t border-stroke-separator" }
const _hoisted_25 = { class: "flex items-center gap-2" }
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "flex items-center space-x-2" }
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = { class: "flex md:hidden mt-7" }
const _hoisted_30 = { class: "flex flex-col gap-1 pl-3 pr-9 py-3 border border-stroke-separator bg-layer-2 rounded-[10px]" }
const _hoisted_31 = { class: "text-text-neutral-extreme font-bold text-sm" }
const _hoisted_32 = { class: "text-text-neutral-medium text-sm" }

import { computed, onMounted, ref, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue'
import api from '@/services/api2.service'
import { Pagination } from '@/types/pagination'

// STORE

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationMembersView',
  setup(__props) {

const store = useStore()
const organization = computed(() => store.getters['nonpersist/getUserOrganization'])
const organizationId = computed(() => organization.value?.id)

// STATE
const loading = ref(false)
const error = ref<string | null>(null)
const orgInfo = ref<any>(null)
const members = ref<any[]>([])

const pagination = ref<Pagination>({
  total_pages: 1,
  items_per_page: 8,
  current_page: 1,
  total_items: 0
})

const perPageOptions = [8, 16, 24]

// RESOURCES
const resourcesUsed = computed(() => {
  const resources = orgInfo.value?.resources

  if (!resources?.length) return 0

  return Math.ceil(
      resources
          .reduce(
              (sum: number, r: any) => sum + (r.used_resources || 0),
              0
          )
  )
})

const resourcesAvailable = computed(() => {
  const resources = orgInfo.value?.resources

  if (!resources?.length) return 0

  return Math.ceil(
      resources
          .filter((r: any) => r.status !== 'expired')
          .reduce(
              (sum: number, r: any) => sum + (r.total_resources || 0),
              0
          )
  )
})

const resourcesUserFromActive = computed(() => {
  const resources = orgInfo.value?.resources

  if (!resources?.length) return 0

  return Math.ceil(
      resources
          .filter((r: any) => r.status !== 'expired')
          .reduce(
              (sum: number, r: any) => sum + (r.used_resources || 0),
              0
          )
  )
})

const resourcesRemaining = computed(() => {
  console.log(resourcesAvailable.value - resourcesUserFromActive.value)
  return resourcesAvailable.value - resourcesUserFromActive.value;
})


// PAGINATION UI
const displayPages = computed(() => {
  const { total_pages, current_page } = pagination.value
  if (!total_pages) return []
  const pages: (number | '...')[] = [1]
  if (current_page > 3) pages.push('...')
  for (let i = current_page - 1; i <= current_page + 1; i++) {
    if (i > 1 && i < total_pages) pages.push(i)
  }
  if (current_page < total_pages - 2) pages.push('...')
  if (total_pages > 1) pages.push(total_pages)
  return pages
})

// SEARCH
const search = ref('')
const searchOpen = ref(false)
const searchInput = ref<HTMLInputElement | null>(null)

// API
async function fetchMembers(page = pagination.value.current_page, force = false) {
  if (!force && page === pagination.value.current_page) return
  try {
    loading.value = true
    const { data } = await api.get(`/organization/users/${organizationId.value}`, {
      params: {
        page,
        per_page: pagination.value.items_per_page,
        filter_search_keyword: search.value || undefined,
        sort_by: 'used',
        sort_type: 'DESC'
      }
    })
    members.value = data?.result?.items ?? []
    pagination.value = data?.result?.pagination ?? pagination.value
  } catch (err: any) {
    error.value = err?.response?.data?.message || 'Failed to load members'
  } finally {
    loading.value = false
  }
}

function goToPage(page: number, force = false) {
  return fetchMembers(page, force)
}

function searchAction() {
  if (!searchOpen.value) {
    searchOpen.value = true
    nextTick(() => searchInput.value?.focus())
    return
  }
  pagination.value.current_page = 1
  fetchMembers(1, true)
}

function clearSearch() {
  search.value = ''
  searchOpen.value = false
  pagination.value.current_page = 1
  fetchMembers(1, true)
}

function onSearchBlur() {
  if (!search.value) searchOpen.value = false
}

function formatDuration(seconds: number): string {
  if (!seconds || seconds < 0) return '0h 0m'

  const h = Math.floor(seconds / 3600)
  let m = Math.ceil((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60);

  if (s > 0 && m <= 0) {
    m++;
  }

  return `${h}h ${m}m`
}


// WATCHERS
watch(
    () => pagination.value.items_per_page,
    async (n, o) => {
      if (n === o) return
      pagination.value.current_page = 1
      await fetchMembers(1, true)
    }
)

// INIT
onMounted(async () => {
  const { data } = await api.get(`/organization/info/${organizationId.value}`)
  orgInfo.value = data?.result ?? null
  await fetchMembers(1, true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('org_summary_title')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('org_summary_used_title')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(formatDuration(resourcesUsed.value)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common_available')), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(formatDuration(resourcesRemaining.value)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center max-w-full overflow-hidden", { 'border border-stroke-resting rounded-[6px] bg-elements-clear': searchOpen.value }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center h-10 transition-all duration-200 ease-out overflow-hidden", searchOpen.value ? 'w-64 px-3 opacity-100' : 'w-0 px-0 opacity-0'])
          }, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "searchInput",
              ref: searchInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              type: "text",
              placeholder: "Search",
              class: "flex-1 bg-transparent outline-none text-md text-text-neutrals-placeholder placeholder-text-neutrals-placeholder",
              onBlur: onSearchBlur,
              onKeydown: _withKeys(_withModifiers(searchAction, ["prevent"]), ["enter"])
            }, null, 40, _hoisted_13), [
              [_vModelText, search.value]
            ]),
            (search.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: clearSearch,
                  class: "ml-2 text-text-neutrals-placeholder hover:text-text-neutrals-primary"
                }, " ✕ "))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            onClick: searchAction,
            class: _normalizeClass(["h-10 w-10 flex items-center justify-center text-text-neutrals-placeholder hover:text-text-neutrals-primary shrink-0 cursor-pointer", { 'bg-button-secondary-mono-resting': searchOpen.value }])
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
              })
            ], -1)
          ]))], 2)
        ], 2),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, _toDisplayString(pagination.value.total_items) + " Members", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("table", _hoisted_16, [
          _cache[5] || (_cache[5] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { style: {"width":"30%"} }),
            _createElementVNode("col", { style: {"width":"30%"} }),
            _createElementVNode("col", { style: {"width":"20%"} }),
            _createElementVNode("col", { style: {"width":"13%"} })
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "bg-layer-1 border-b border-stroke-separator text-text-neutral-medium text-xs" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Name"),
              _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Email"),
              _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Usage"),
              _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Status")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: member.id,
                class: "hover:bg-gray-750"
              }, [
                _createElementVNode("td", _hoisted_18, _toDisplayString(member.name), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(member.email), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(formatDuration(member.used)), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["w-2 h-2 rounded-full", {
                    'bg-elements-blue': member.status === 'active',
                    'bg-elements-red': member.status === 'deleted'
                  }])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(member.status), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_unref(Listbox), {
            modelValue: pagination.value.items_per_page,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.items_per_page) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_unref(ListboxButton), { class: "min-w-[64px] bg-elements-clear border border-stroke-separator rounded-lg py-1.5 pl-2 pr-8 text-sm text-text-neutrals-primary focus:outline-none" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(pagination.value.items_per_page) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "pointer-events-none absolute inset-y-0 right-2 flex items-center" }, [
                      _createElementVNode("svg", {
                        class: "h-4 w-4 text-text-neutrals-placeholder",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.38a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z",
                          "clip-rule": "evenodd"
                        })
                      ])
                    ], -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ListboxOptions), { class: "absolute mt-1 w-full rounded-lg border border-stroke-separator bg-elements-clear shadow-lg z-50" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(perPageOptions, (n) => {
                      return _createVNode(_unref(ListboxOption), {
                        key: n,
                        value: n
                      }, {
                        default: _withCtx(({ active, selected }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["cursor-pointer px-2 py-1.5 text-sm", [
                    active ? 'bg-layer-2' : '',
                    selected ? 'font-medium' : ''
                  ]])
                          }, _toDisplayString(n), 3)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-text-neutrals-placeholder text-sm" }, "per page", -1))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: _normalizeClass(["px-2 py-1 rounded-lg", { 'opacity-30 cursor-default': pagination.value.current_page === 1, 'cursor-pointer': pagination.value.current_page !== 1 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (pagination.value.current_page > 1 && goToPage(pagination.value.current_page - 1)))
          }, " ‹ ", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayPages.value, (page, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              onClick: ($event: any) => (page !== '...' && goToPage(page)),
              class: _normalizeClass(["px-3 py-1.5 rounded-lg text-sm", [
            page === pagination.value.current_page
              ? 'bg-gray-700 text-white'
              : page === '...'
                ? 'cursor-default text-gray-500'
                : 'text-gray-400 hover:bg-gray-700 hover:text-white cursor-pointer',
          ]]),
              disabled: page === '...'
            }, _toDisplayString(page), 11, _hoisted_28))
          }), 128)),
          _createElementVNode("button", {
            class: _normalizeClass(["px-2 py-1 rounded-lg", { 'opacity-30 cursor-default': pagination.value.current_page === pagination.value.total_pages, 'cursor-pointer': pagination.value.current_page !== pagination.value.total_pages }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (pagination.value.current_page < pagination.value.total_pages && goToPage(pagination.value.current_page + 1)))
          }, " › ", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.$t('mobile_detected_title')), 1),
        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('mobile_detected_text')), 1)
      ])
    ])
  ]))
}
}

})